// extracted by mini-css-extract-plugin
module.exports = {"selectedNotation":"Notation_selectedNotation__3wsjJ"};